import { render } from "./MapContent.vue?vue&type=template&id=bfccb886"
import script from "./MapContent.vue?vue&type=script&lang=js"
export * from "./MapContent.vue?vue&type=script&lang=js"

import "./MapContent.vue?vue&type=style&index=0&id=bfccb886&lang=css"

import exportComponent from "/home/runner/work/projeto_logistica/projeto_logistica/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Itineraries/MapContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bfccb886"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bfccb886', __exports__)) {
    console.log('reload')
    api.reload('bfccb886', __exports__)
  }
  
  module.hot.accept("./MapContent.vue?vue&type=template&id=bfccb886", () => {
    console.log('re-render')
    api.rerender('bfccb886', render)
  })

}


export default __exports__